module.exports = __webpack_public_path__ + "static/media/permata.d1a3540b.png";